export type PlanKey = "STANDARD" | "PRO" | "AGENCY";
export type PlanKeyExt = PlanKey | "OWNER";

/**
 * Normalizes backend tier tokens into UI plan keys.
 * Backend currently emits: FREE | PRO | AGENCY | OWNER | null/undefined.
 */
export function normalizePlanKey(raw?: string | null): PlanKeyExt {
  const t = (raw ?? "").toUpperCase();
  if (t === "OWNER") return "OWNER";
  if (t === "AGENCY") return "AGENCY";
  if (t === "PRO") return "PRO";
  // Treat FREE/empty/unknown as Standard for display
  return "STANDARD";
}

export function planKeyToBackendTier(key: PlanKeyExt): string {
  // This mirror maps Standard to the legacy FREE value while letting owner options pass through.
  if (key === "STANDARD") return "STANDARD";
  return key;
}

export function planLabel(raw?: string | null): string {
  const k = normalizePlanKey(raw);
  if (k === "OWNER") return "Owner";
  if (k === "AGENCY") return "Agency";
  if (k === "PRO") return "Pro";
  return "Standard";
}
